<template>
  <section style="height: 100%;">
    <v-app-bar app class="header">
      <div class="header__principal">
        <v-toolbar-title><app-logo class="app_logo"></app-logo></v-toolbar-title>
      </div>
      <div class="header__close_session" @click="closeSession()">
        <v-icon>logout</v-icon>
        <p>Salir</p>
      </div>
    </v-app-bar>
    <v-main class="monitoring" style="padding: 0;">
      <router-view></router-view>
    </v-main>
  </section>
</template>
<script>
export default {
  methods: {
    closeSession() {
      this.updateUserToken(null)
      this.updateIsLogin(false)
      this.updateUserId('')
      this.updateMonitoredCompanies([])
      this.updateSelectedCompany(null)
      this.$router.push({ name: "login" })
    },
  }
}
</script>